var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-autocomplete', {
    staticClass: "account-connection-autocomplete",
    attrs: {
      "filter": _vm.filterObject,
      "loading": _vm.accountLoading,
      "items": _vm.accountItems,
      "item-value": "id",
      "label": _vm.isEmployee ? 'Account for employee' : 'Account for customer',
      "item-text": "fullName",
      "dense": _vm.dense,
      "return-object": "",
      "clean": "",
      "clearable": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "update:search-input": _vm.handleInput
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (_ref) {
        var props = _ref.props,
          item = _ref.item;
        return [_c('div', {
          staticClass: "d-flex flex-column gap-2"
        }, [_c('div', [_c('strong', [_vm._v(_vm._s(item.fullName))])]), _c('div', {
          staticStyle: {
            "font-size": "14px"
          }
        }, [_vm._v(" " + _vm._s(item.email) + " ")])])];
      }
    }]),
    model: {
      value: _vm.selectedItem,
      callback: function ($$v) {
        _vm.selectedItem = $$v;
      },
      expression: "selectedItem"
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }